declare namespace $ {

	export class $mol_icon_repeat_once extends $mol_icon {
		path( ): string
	}
	
}

//# sourceMappingURL=once.view.tree.d.ts.map